// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newPasswordContainer{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.passwordInputContainer{
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 56px;
}
.secondPasswordContainer{
    margin-top: 10px;
}

@media (max-width: 1640px) {
    .passwordInputContainer{
        margin-top: 50px;
    }
}
@media (max-width: 1440px) {
    .passwordInputContainer{
        margin-top: 40px;
    }
}

@media (max-width: 1280px) {
    .passwordInputContainer{
        margin-top: 30px;
    }
}

@media (max-width: 1024px) {
    .passwordInputContainer{
        margin-top: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/SignInFlow/Newpassword/NewPassword.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".newPasswordContainer{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n.passwordInputContainer{\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    margin-top: 56px;\n}\n.secondPasswordContainer{\n    margin-top: 10px;\n}\n\n@media (max-width: 1640px) {\n    .passwordInputContainer{\n        margin-top: 50px;\n    }\n}\n@media (max-width: 1440px) {\n    .passwordInputContainer{\n        margin-top: 40px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .passwordInputContainer{\n        margin-top: 30px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .passwordInputContainer{\n        margin-top: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
